import { faAddressBook } from '@fortawesome/free-solid-svg-icons/faAddressBook';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons/faAngleDoubleLeft';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faBold } from '@fortawesome/free-solid-svg-icons/faBold';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons/faCircleNotch';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faFileUpload } from '@fortawesome/free-solid-svg-icons/faFileUpload';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faItalic } from '@fortawesome/free-solid-svg-icons/faItalic';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faListOl } from '@fortawesome/free-solid-svg-icons/faListOl';
import { faListUl } from '@fortawesome/free-solid-svg-icons/faListUl';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faMoneyBillWave } from '@fortawesome/free-solid-svg-icons/faMoneyBillWave';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faShare } from '@fortawesome/free-solid-svg-icons/faShare';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faSuperscript } from '@fortawesome/free-solid-svg-icons/faSuperscript';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faAddressBook);
library.add(faAngleDoubleLeft);
library.add(faAngleDoubleRight);
library.add(faAngleLeft);
library.add(faAngleRight);
library.add(faBold);
library.add(faCheck);
library.add(faCheckCircle);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faCircleNotch);
library.add(faClock);
library.add(faDownload);
library.add(faEdit);
library.add(faEnvelope);
library.add(faExclamationCircle);
library.add(faEye);
library.add(faFacebook);
library.add(faFileUpload);
library.add(faGoogle);
library.add(faLink);
library.add(faInfoCircle);
library.add(faInstagram);
library.add(faItalic);
library.add(faLinkedin);
library.add(faListOl);
library.add(faListUl);
library.add(faMinus);
library.add(faMoneyBillWave);
library.add(faPhone);
library.add(faPlus);
library.add(faRedo);
library.add(faSearch);
library.add(faShare);
library.add(faShoppingCart);
library.add(faSignOutAlt);
library.add(faSuperscript);
library.add(faTimes);
library.add(faTrashAlt);
library.add(faTruck);
library.add(faTwitter);
library.add(faUndo);
library.add(faUser);
library.add(faYoutube);
